export async function getIsTrackAllChangesOn() {
  let trackingMode;

  await window.Word.run(async context => {
    const doc = context.document;
    doc.load("changeTrackingMode");
    await context.sync();

    trackingMode = doc.changeTrackingMode;
    // if (doc.changeTrackingMode === Word.ChangeTrackingMode.off) {
    //   console.log("Track Changes is off");
    // } else if (doc.changeTrackingMode === Word.ChangeTrackingMode.trackAll) {
    //   console.log("Track Changes is on for everyone");
    // } else if (doc.changeTrackingMode === Word.ChangeTrackingMode.trackMineOnly) {
    //   console.log("Track Changes is on for my changes only");
    // }
  });

  return trackingMode === Word.ChangeTrackingMode.trackAll;
}
